import { render, staticRenderFns } from "./FormStyle.vue?vue&type=template&id=667659ae"
import script from "./FormStyle.vue?vue&type=script&lang=js"
export * from "./FormStyle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports